import { MAX_TARGET_DATES } from '~/pages/WorkflowCases/constants/targetDates'

/**
 * 対象日入力行 (`TargetDateFields`) の上限判定 (F1 抽出、挙動不変)。
 *
 * 判定は**行数** (`rowCount`) で行う。実効日数 (重複除去後) ではなく行数で見る
 * 理由は `TargetDateFields.tsx` 内の同名判定のコメント参照 (実効日数で緩めると、
 * 同じ日付で行を増やしてから各行を別の日付に編集する経路で
 * `MAX_TARGET_DATES` を超えられる)。
 */
export function isTargetDateRowLimitReached(rowCount: number): boolean {
  return rowCount >= MAX_TARGET_DATES
}
